import idConfig from 'utils/ecommerce/services/id.config';
import { getLanguage } from 'utils/language/language';
import { env as E } from 'config/app.config';

export const getProductById = ({ productId, itemType }: any): any => {
	const language = (idConfig.LANGUAGE as any)[getLanguage().toUpperCase()];
	const storeId = (idConfig.ESHOP as any)?.['PRODUCTS']?.['STORE_ID']?.[E];
	const catalogId = (idConfig.ESHOP as any)?.['PRODUCTS']?.['CATALOG_ID']?.[E];
	return {
		url: `/search/resources/api/v2/products?productId=${productId}&storeId=${storeId}&langId=${language}&catalogId=${catalogId}${
			itemType ? '&defItemType=' + itemType : ''
		}`,
	};
};
